let jquery;
if (window.jQuery) {
  jquery = window.jQuery;
}

jquery(document).ready(function(){
  let fullBanner = jquery(jquery("div.image-banner")[0]);
  let mobileBanner = jquery(jquery("div.image-banner")[1]);
  if (!jquery("html").hasClass("shopify-design-mode")) {
    if (jquery(window).width() <= 480) { // Mobile client
      jquery(fullBanner).parent().css("display","none");
      jquery(mobileBanner).find("div.banner__media").css({"width":"304px","height":"304px"});
      jquery(mobileBanner).parent().css("display","block");
      jquery(mobileBanner).parent().removeClass("spaced-section");
      jquery(mobileBanner).find("a.image-banner__button").addClass("gallery-with-text__button").removeClass("image-banner__button");
    } else { // Full client
      jquery(mobileBanner).parent().css("display","none");
      jquery(fullBanner).parent().css("display","block");
    }
  } else { // Editing the page
    jquery(fullBanner).parent().css("display","block");
    jquery(mobileBanner).parent().css("display","block");    
    jquery(mobileBanner).find("a.image-banner__button").addClass("gallery-with-text__button").removeClass("image-banner__button");
  }
});
